export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7443_TEAM___': 'TEAM',
    '_11080_FRONT_LINE_WINNING_PERCENTAGE___': 'Front Line Winning %',
    '_11142_COMMITMENTS_ASSESSED___': 'Commitments Assessed',
    '_11143_WINNING_DATA___': 'Winning Data',
    '_10085_WINNING___': 'Winning',
    '_10086_NEUTRAL___': 'Neutral',
    '_10087_LOSING___': 'Losing',
    '_10088_TOTAL___': 'Total',
    '_9879_NO_SCORE___': 'No Score',
    '_709_DATE_RANGE___': 'Date Range',
    '_10081_DATE_RANGE_IS_THAT___': 'Only coaching events that occur within the Coaching Event Range are considered in the winning % calculation',
    '_10082_EVALUATION_RANGE___': 'Evaluation Range',
    '_10083_THE_EVALUATION_RANGE_IS___': 'The evaluation range is the amount of days after a goal is set that the event is evaluated to determine if the event is a winning, losing, or neutral event',
    '_7313_LAST_UPDATE___': 'Last Update',
    '_9395_RESET_GRID___': 'Reset Grid',
    '_11144_SUPERGROUP_NAME___': 'SuperGroup Name',
    '_11145_DAYS_IN_SUPERGROUP___': 'Days in SuperGroup',
    '_48_MANAGER___': 'Manager',
    '_59_ROLE___': 'Role',
    '_10084_SELECTED_PERIOD___': 'Selected Period',
    '_11146_No_FRONT_LINE_WINNING_DATA___': 'No Frontline Winning % Data is available',
    '_7495_BACK_TO_PREVIOUS_VIEW___': 'Back to Previous View'
};
